import { useEffect } from 'react'
import { Link, isRouteErrorResponse, useRouteError } from 'react-router'
import { reportError } from '../lib/errorReporter'
import { Logo } from '../components/ui'

export function RouteError() {
  const error = useRouteError()
  if (import.meta.env.DEV) console.error(error)
  // 404-style route responses are not bugs; thrown render/loader errors are.
  useEffect(() => {
    if (import.meta.env.PROD && !isRouteErrorResponse(error)) reportError(error, 'route')
  }, [error])
  return (
    <main className="flex min-h-screen flex-col items-center justify-center gap-6 px-4 text-center">
      <Logo />
      <h1 className="font-head text-3xl font-semibold tracking-tight">Something broke on this page</h1>
      <p className="max-w-md text-muted">Reload to try again. If it keeps happening, write to hi@automatics.dev and tell us what you clicked.</p>
      <div className="flex gap-3">
        <button type="button" className="btn btn-ghost" onClick={() => window.location.reload()}>
          Reload
        </button>
        <Link to="/" className="btn btn-primary">
          Home
        </Link>
      </div>
    </main>
  )
}
